export default "__VITE_ASSET__Bvgv5Q5M__"